/**
 * BillingWalletApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { SettlementDto } from '../model/settlementDto';
import { SettlementTransactionLogModel } from '../model/settlementTransactionLogModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SettlementService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSettlementCreatePost(body?: SettlementDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiSettlementCreatePost(body?: SettlementDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiSettlementCreatePost(body?: SettlementDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiSettlementCreatePost(body?: SettlementDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/Settlement/Create`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSettlementGet(observe?: 'body', reportProgress?: boolean): Observable<Array<SettlementTransactionLogModel>>;
    public apiSettlementGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SettlementTransactionLogModel>>>;
    public apiSettlementGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SettlementTransactionLogModel>>>;
    public apiSettlementGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SettlementTransactionLogModel>>('get',`${this.basePath}/api/Settlement`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientAuthId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSettlementGetAllByClientAuthIdGet(clientAuthId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SettlementTransactionLogModel>>;
    public apiSettlementGetAllByClientAuthIdGet(clientAuthId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SettlementTransactionLogModel>>>;
    public apiSettlementGetAllByClientAuthIdGet(clientAuthId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SettlementTransactionLogModel>>>;
    public apiSettlementGetAllByClientAuthIdGet(clientAuthId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientAuthId !== undefined && clientAuthId !== null) {
            queryParameters = queryParameters.set('clientAuthId', <any>clientAuthId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SettlementTransactionLogModel>>('get',`${this.basePath}/api/Settlement/GetAllByClientAuthId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param merchantAuthId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSettlementGetAllByMerchantAuthIdGet(merchantAuthId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SettlementTransactionLogModel>>;
    public apiSettlementGetAllByMerchantAuthIdGet(merchantAuthId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SettlementTransactionLogModel>>>;
    public apiSettlementGetAllByMerchantAuthIdGet(merchantAuthId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SettlementTransactionLogModel>>>;
    public apiSettlementGetAllByMerchantAuthIdGet(merchantAuthId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantAuthId !== undefined && merchantAuthId !== null) {
            queryParameters = queryParameters.set('merchantAuthId', <any>merchantAuthId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SettlementTransactionLogModel>>('get',`${this.basePath}/api/Settlement/GetAllByMerchantAuthId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param settlementId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSettlementGetByIdGet(settlementId?: string, observe?: 'body', reportProgress?: boolean): Observable<SettlementTransactionLogModel>;
    public apiSettlementGetByIdGet(settlementId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SettlementTransactionLogModel>>;
    public apiSettlementGetByIdGet(settlementId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SettlementTransactionLogModel>>;
    public apiSettlementGetByIdGet(settlementId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (settlementId !== undefined && settlementId !== null) {
            queryParameters = queryParameters.set('settlementId', <any>settlementId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SettlementTransactionLogModel>('get',`${this.basePath}/api/Settlement/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
